module.exports = __webpack_public_path__ + "img/square-caret-down.3db8ec1b.svg";